import React from 'react'
import { Spinner, Container } from 'reactstrap'
import styled from 'styled-components'

const LoadingContainer = styled(Container)`
  display: flex;
  justify-content: center;
  min-height: 400px;
  align-items: center;
`
const LoadingSpinner = () => {
  return (
    <LoadingContainer>
      <Spinner color="primary" style={{ width: '3rem', height: '3rem' }} />
    </LoadingContainer>
  )
}

export default LoadingSpinner
